import {IMessageListRuleTag} from "./MessagingListRuleQueryBuilder";
import React from "react";
import {DropdownMenu, Select} from "@radix-ui/themes";
import useTheme from "../../radix/useTheme";
import useSWR from "swr";
import WatsonApi from "../../../backends/WatsonApi";
import {useStores} from "../../../stores/useStores";
import {MessagingListQueryOptions} from "./MessagingListRules";

export function RuleOrganizationDropdown(props: {
    organization: IMessageListRuleTag | null,
    setOrganization: React.Dispatch<React.SetStateAction<IMessageListRuleTag | null>>
}) {
    const {organizationStore} = useStores();
    const radixTheme = useTheme();

    const {data} = useSWR("user-organization-roles", async () => {
        const client = await WatsonApi();
        const response = await client.apis.organizations.organizations_list({
            organization_pk: organizationStore.organization.id,
            path__descendant_or_eq: organizationStore.organization.path,
            with_role: true,
            deleted: "false",
            ordering: "title",
            fields: ["title", "id"]
        });
        const results = JSON.parse(response.data).data;
        return results.map((org) => ({
            value: org.title,
            type: MessagingListQueryOptions.Organization,
            filter: org.id,
        }));
    })

    return <Select.Root
        value={props.organization ? JSON.stringify(props.organization) : undefined}
        onValueChange={value => props.setOrganization(JSON.parse(value))}
    >
        <Select.Trigger placeholder={"Select Organization"}/>
        <Select.Content container={radixTheme.portalContainer?.current} position={"popper"}>
            {data?.map((org: IMessageListRuleTag) => <Select.Item value={JSON.stringify(org)}>
                {org.value}
            </Select.Item>)}
        </Select.Content>
    </Select.Root>
}